import React from "react";
import CTASection from "../sections/cta-section";

function RankingsBanner() {
  return <CTASection className="w-full h-full object-cover" />;
}
export default RankingsBanner;
